"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.854 1.68C17.49 1.593 15.25 1.5 12 1.5s-5.489.094-6.854.18c-1.308.08-2.38 1.047-2.513 2.386-.103 1.037-.2 2.57-.2 4.667s.097 3.63.2 4.668c.133 1.338 1.205 2.305 2.513 2.387 1.365.085 3.604.179 6.854.179s5.489-.094 6.854-.18c1.308-.081 2.38-1.048 2.513-2.386.103-1.037.2-2.57.2-4.668 0-2.097-.097-3.63-.2-4.667-.133-1.339-1.205-2.305-2.513-2.387ZM12 3.6c2.892 0 4.898.07 6.137.133.653.034 1.127.48 1.186 1.07.077.758.144 1.823.144 3.23 0 1.408-.067 2.473-.144 3.23-.06.591-.533 1.036-1.186 1.07-1.239.064-3.245.134-6.137.134-2.892 0-4.898-.07-6.137-.134-.653-.034-1.127-.479-1.186-1.07a32.393 32.393 0 0 1-.144-3.23c0-1.407.067-2.472.144-3.23.06-.59.533-1.036 1.186-1.07C7.102 3.67 9.108 3.6 12 3.6ZM3.321 22.435c1.47.026 4.364.065 8.679.065 4.314 0 7.207-.039 8.678-.065.502-.01.98-.223 1.292-.601.326-.397.44-.947.213-1.49-.293-.704-.755-1.42-1.203-2.01a2.33 2.33 0 0 0-1.804-.906c-.988-.026-3.073-.061-7.176-.061-4.104 0-6.189.035-7.177.061a2.33 2.33 0 0 0-1.804.906c-.448.59-.91 1.306-1.203 2.01a1.436 1.436 0 0 0 .213 1.49c.311.378.79.592 1.292.6Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDesktop);
var _default = exports["default"] = Memo;